import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { server } from '../app/conf'
@Injectable({
  providedIn: 'root'
})
export class CaseUploadService {
  constructor(private http: HttpClient) { }
  uploadCase(acase, file: File) {
    const formData = new FormData();
    formData.append('caseZipFile', file, file.name);
    formData.append('client', acase.client);
    formData.append('subclient', acase.subclient);
    formData.append('candidateName', acase.candidateName);
    console.log("Tat being sent is ", acase.tat);
    formData.append('tat', String(acase.tat));
    console.log('status before appending to form data ', acase.status);
    formData.append("status", acase.status);
    if (acase.batch != null) {
      formData.append('batch', acase.batch);
    }
    if (acase.package != null) {
      formData.append('package', acase.package);
    } else if (acase.profile != null) {
      formData.append('profile', acase.profile);
    } else {
      console.log('about to stringify components to check ', acase.componentsToCheck);
      console.log('Stringified components to check ', JSON.stringify(acase.componentsToCheck));
      formData.append('componentsToCheck', JSON.stringify(acase.componentsToCheck))
    }

    //    formData.append('file',file);
    const header = new HttpHeaders();
    const params = new HttpParams();
    const options = {
      params,
      reportProgress: true,
      headers: header
    }
    return this.http.post<any>(`${server}cases`, formData, options);
  }
  addACheck(case_id, checkToAdd) {
    return this.http.put<any>(`${server}cases/addacheck/${case_id}`, checkToAdd)
  }
  uploadLoa(caseId, file, fileName) {
    const formData = new FormData();

    formData.append('loaFile', file, file.name);
    formData.append('fileName', fileName);
    formData.append("caseId", caseId);
    const header = new HttpHeaders();
    const params = new HttpParams();
    const options = {
      params,
      reportProgress: true,
      headers: header
    }
    return this.http.post<any>(`${server}cases/uploadloa`, formData)
  }
  createABatchCase(caseData) {
    return this.http.post<any>(`${server}cases/batchcase`, caseData);
  }
  uploadExcelCase(caseData) {
    return this.http.post<any>(`${server}cases/uploadexcelcase`, caseData);
  }
  findAllForAClientAndSubclient(clientId: string, subclientId: string) {
    return this.http.get<any[]>(`${server}cases/client/${clientId}/subclient/${subclientId}`);
  }
  findACase(caseId: string) {
    return this.http.get<any>(`${server}cases/case/${caseId}`);
  }
  findAllForABatch(batch: string) {
    return this.http.get<any[]>(`${server}cases/batch/${batch}`);
  }
  findOneDeUnAllocatedCase() {
    return this.http.get<any>(`${server}cases/findonedeunallocated`);
  }
  downloadCandidateFile(caseId: string) {
    let headers = new HttpHeaders();
    return this.http.get<Blob>(`${server}cases/downloadcandidatefile/${caseId}`, { observe: 'response', responseType: 'blob' as 'json' });
  }
  downloadCaseFileForCDF(caseId: string) {
    let headers = new HttpHeaders();
    return this.http.get<Blob>(`${server}downloadcasefiles/case/${caseId}`, { observe: 'response', responseType: 'blob' as 'json' });
  }
  updateStatus(caseId: string, status) {
    return this.http.put<any>(`${server}cases/case/${caseId}`, status);
  }
  findCasesWithStatus(status: string) {
    return this.http.get<any[]>(`${server}cases/status/${status}`);
  }
  findAllCasesWithStatus(status: string, pageCount) {
    return this.http.get<any>(`${server}cases/allcases/status/${status}?pageCount=${pageCount}`);
  }
  findACaseForReport(caseId, pageCount) {
    return this.http.get<any>(`${server}cases/caseforreport/caseid/${caseId}?pageCount=${pageCount}`);
  }
  findAllPendingCases(client_id, pageCount) {
    return this.http.get<any>(`${server}cases/pendingcases/${client_id}?pageCount=${pageCount}`);
  }
  searchByName(searchValue, pageCount) {
    return this.http.get<any>(`${server}cases/searchbyname/candidatename/${searchValue}?pageCount=${pageCount}`);
  }
  searchByCaseId(searchValue, pageCount) {
    return this.http.get<any>(`${server}cases/searchbycaseid/caseid/${searchValue}?pageCount=${pageCount}`);
  }
  searchByCaseIdNoRestrictions(searchValue, pageCount) {
    return this.http.get<any>(`${server}cases/searchbycaseidnores/caseid/${searchValue}?pageCount=${pageCount}`);
  }
  searchByInitiationDate(searchDateFrom, searchDateTo, client_id, pageCount) {
    return this.http.get<any>(`${server}cases/searchbyinitiationdate/datefrom/${searchDateFrom}/dateto/${searchDateTo}/${client_id}?pageCount=${pageCount}`);
  }
  searchByCompletionDate(searchDateFrom, searchDateTo, client_id, pageCount) {
    return this.http.get<any>(`${server}cases/searchbycompletiondate/datefrom/${searchDateFrom}/dateto/${searchDateTo}/${client_id}?pageCount=${pageCount}`);
  }
  getDataForCaseStatus(caseList) {
    return this.http.post<any[]>(`${server}allcomponents/casestatusreport`, caseList);
  }
  createImageForReport(case_id) {
    return this.http.get<any>(`${server}allcomponents/createimageforreport/${case_id}`)
  }
  updateCaseStatus(case_id, statusToUpdate) {
    return this.http.put<any>(`${server}allcomponents/updatecasestatus/${case_id}`, statusToUpdate)
  }
  allocateCaseToUser(case_id, user_id) {
    return this.http.put<any>(`${server}cases/allocatetouser/${case_id}`, user_id);
  }
  getCasesInOutputqc() {
    return this.http.get<any[]>(`${server}allcomponents/getcasesinoutputqc`);
  }
  setOutputqcGrade(case_id, caseDetails) {
    return this.http.put<any>(`${server}cases/setoutputqcgrade/${case_id}`, caseDetails)
  }
  updateInsuffRaisedDate(case_id, caseDetails) {
    return this.http.put<any>(`${server}cases/updateinsuffraiseddate/${case_id}`, caseDetails)
  }
  updateInsuffClearedDate(case_id, caseDetails) {
    return this.http.put<any>(`${server}cases/updateinsuffcleareddate/${case_id}`, caseDetails)
  }
  uploadPdfReport(acase, file: File, fileTitle) {
    const formData = new FormData();
    formData.append('reportFile', file, file.name);
    formData.append('caseId', acase.caseId);
    formData.append('fileName', fileTitle)
    formData.append("reportType", acase.reportType);
    const header = new HttpHeaders();
    const params = new HttpParams();
    const options = {
      params,
      reportProgress: true,
      headers: header
    }
    return this.http.post<any>(`${server}cases/uploadpdfreport`, formData, options);
  }
  uploadCdeCase(aCase) {
    const header = new HttpHeaders();
    const params = new HttpParams();
    const options = {
      params,
      reportProgress: true,
      headers: header
    }
    return this.http.post<any>(`${server}cases/initiatecdecase`, aCase);
  }
  resendMail(_id, aCase) {
    return this.http.put<any>(`${server}cases/resendmail/${_id}`, aCase)
  }
  readUploadedPdfReportFileNames(caseId) {
    return this.http.get<any[]>(`${server}cases/readreportfilenames/${caseId}`)
  }
  downloadPdfReport(caseId, reportType, fileName) {
    return this.http.get<Blob>(`${server}cases/downloadpdfreport?caseId=${caseId}&&reportType=${reportType}&&fileName=${fileName}`, { observe: 'response', responseType: 'blob' as 'json' })
  }
  countCasesBetweenDates(dateFrom, dateTo, countType) {
    return this.http.get<any>(`${server}cases/casecount?countType=${countType}&&dateFrom=${dateFrom}&&dateTo=${dateTo}`)
  }
  getLastSixmonthsCount() {
    return this.http.get<any[]>(`${server}cases/lastsixmonthscount`)
  }
  getCdeCaseDetails(accessToken) {
    return this.http.get<any>(`${server}cdecase/getcdecasedetails?access_token=${accessToken}`)
  }
  getComponentToCheck(component_id, caseId) {
    return this.http.get<any>(`${server}cdecase/getComponentToCheck/${component_id}/${caseId}`)
  }
  saveAuthorizationSignature(base64Data, accessToken) {
    return this.http.post<any>(`${server}cdecase/saveauthorizationsignature?access_token=${accessToken}`, { signature: base64Data })
  }

}
